import React from "react";
import { ConfigProvider, theme } from "antd";

const ThemeProvider = ({
  children,
  isDarkMode = false,
  primaryColor = "#1677ff",
}) => {
  return (
    <ConfigProvider
      theme={{
        // algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          // colorPrimary: primaryColor,
        },
        components: {
          Input: {
            paddingBlock: 5, // Vertical padding
            paddingInline: 12, // Horizontal padding
            colorPrimary: "#061b49", // Red border when focused
            colorPrimaryHover: "#061b49", // Slightly lighter red on hover
            lineWidthFocus: 3, // Border thickness when focused
            inputFontSize: 17,
          },
          Form: {
            labelFontSize: 18, // Increase label font size
            labelColor: "#333", // Optional: Change label color
            labelFontWeight: 600, // Optional: Make label bold
          },
          Select: {
            paddingBlock: 10, // Vertical padding
            paddingInline: 12, // Horizontal padding
            colorPrimary: "#061b49", 
            colorPrimaryHover: "#061b49",
            lineWidthFocus: 3,
            inputFontSize: 17,
            optionFontSize:16,
            optionSelectedBg: "#5379c6",
          },
          DatePicker:{

            activeBorderColor: "#5379c6",
          }
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default ThemeProvider;
